import { colors } from "config/styles/themeColors";

const styles = {
  itemsWrap: {
    mt: "30px",
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "center",
    rowGap: "30px",
    columnGap: "20px",
  },
  link: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "10px",
    color: colors.text.primary,
    textDecoration: "none",

    "& > p": {
      position: "relative",
      "&::after": {
        content: '""',
        position: "absolute",
        width: "0%",
        height: "1px",
        bottom: 0,
        left: "50%",
        backgroundColor: colors.text.primary,
        transition: "all 0.5s ease",
      },
    },

    "&:hover > p::after": {
      width: {
        xs: "unset",
        lg: "100%",
      },
      left: "0%",
    },

    "&:hover > .MuiBox-root > svg": {
      width: "120px",
      height: "120px  ",
    },
  },
  iconWrap: {
    width: "150px",
    height: "150px",
    borderRadius: "10px",
    border: "1px solid",
    borderColor: colors.gray.disabled,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",

    "& > svg": {
      width: "100px",
      height: "100px",
      fill: colors.text.secondary,
      transition: "all 0.5s ease",
    },
  },
};

export default styles;
